import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faCalendarAlt,
  faThLarge,
  faListAlt,
  faBan,
  faFileAlt,
  faEnvelope,
  faImage,
  faStar,
  faKey,
  faSignOutAlt,
  faBullhorn,
  faQuestionCircle,
  faCheckCircle,
  faHourglassHalf,
  faFileCode,
  faUsers,
  faCreditCard
} from '@fortawesome/free-solid-svg-icons';
import DataService from '../../services/data.service';

const Sidebar = ({ expanded }) => {
  const navigate = useNavigate();

  const logout = () => {
    DataService.deleteAccessToken();
    navigate('/login');
  };

  return (
     <div
      className={` sidebar d-flex flex-column px-0 ${
        expanded ? 'col-md-3 col-xl-2 sidebar-expanded' : 'col-auto sidebar-collapsed'
      }`} style={{background:'#2c3e50'}}
    >
      
      <div className="d-flex flex-column align-items-sm-start px-3 pt-3 text-white min-vh-100">
        <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-sm-start w-100">
          <SidebarItem to="/dashboard" icon={faTachometerAlt} label="Dashboard" expanded={expanded} />
          <SidebarItem to="/bookings" icon={faCalendarAlt} label="All Bookings" expanded={expanded} />
          <SidebarItem to="/open-bookings" icon={faHourglassHalf} label="Open Bookings" expanded={expanded} />
          <SidebarItem to="/confirmed-bookings" icon={faCheckCircle} label="Confirmed Bookings" expanded={expanded} />
          <SidebarItem to="/users" icon={faUsers} label="Users" expanded={expanded} />
          <SidebarItem to="/booking-questions" icon={faQuestionCircle} label="Booking Questions" expanded={expanded} />
          <SidebarItem to="/categories" icon={faThLarge} label="Categories" expanded={expanded} />
          <SidebarItem to="/sub-categories" icon={faListAlt} label="Sub Categories" expanded={expanded} />
          <SidebarItem to="/block-dates" icon={faBan} label="Block Dates" expanded={expanded} />
          <SidebarItem to="/page-settings" icon={faFileAlt} label="Page Settings" expanded={expanded} />
          <SidebarItem to="/seo-pages" icon={faFileCode} label="SEO Pages" expanded={expanded} />
          <SidebarItem to="/email-settings" icon={faEnvelope} label="Email Settings" expanded={expanded} />
          <SidebarItem to="/square-settings" icon={faCreditCard} label="Square Settings" expanded={expanded} />
          <SidebarItem to="/customer-images" icon={faImage} label="Customer Images" expanded={expanded} />
          <SidebarItem to="/reviewsListing" icon={faStar} label="Reviews" expanded={expanded} />
           <SidebarItem to="/promotions" icon={faBullhorn} label="Promotions" expanded={expanded} />
          <SidebarItem to="/change-password" icon={faKey} label="Change Password" expanded={expanded} />
          <li className="nav-item w-100" onClick={logout}>
            <NavLink to="/logout" className="nav-link text-white" style={{fontSize:'14px'}}>
              <FontAwesomeIcon icon={faSignOutAlt} />
              {expanded && <span className="ms-2" style={{color:'white', marginLeft:'2px'}}>Logout</span>}
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

const SidebarItem = ({ to, icon, label, expanded }) => (
  <li className="nav-item w-100">
    <NavLink to={to} className="nav-link text-white" style={{fontSize:'14px'}} activeclassname="active">
      <FontAwesomeIcon icon={icon} />
      {expanded && <span className="ms-2" style={{color:'white', marginLeft:'2px'}}>{label}</span>}
    </NavLink>
  </li>
);

export default Sidebar;
